import { render } from "./SoloPicture.vue?vue&type=template&id=1668b806&scoped=true"
import script from "./SoloPicture.vue?vue&type=script&lang=js"
export * from "./SoloPicture.vue?vue&type=script&lang=js"

import "./SoloPicture.vue?vue&type=style&index=0&id=1668b806&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1668b806"]])

export default __exports__